import AppThemeConfiguration from '@deltek/specification-client/core/Configurations/AppThemeConfiguration'
import { AuthProvider } from '@deltek/specification-client/core/Configurations/AuthContext'
import { ReviewerBaseRoles } from '@deltek/specification-client/core/Configurations/Authorization'
import GlobalRouterConfiguration from '@deltek/specification-client/core/Configurations/GlobalRouterConfiguration'
import { AppBarProvider } from '@deltek/specification-client/core/Contexts/AppBarContext'
import { AppInsightContextProvider } from '@deltek/specification-client/core/Contexts/AppInsightsContext'
import {
    ILoadingPageContext,
    LoadingPageContext,
    LoadingPageProvider,
} from '@deltek/specification-client/core/Contexts/LoadingPageContext'
import NavPromptDialogContainer from '@deltek/specification-client/core/Forms/NavPromptDialogContainer'
import LoadingScreenPage from '@deltek/specification-client/core/Pages/LoadingScreenPage'
import React from 'react'
import { BrowserRouter } from 'react-router-dom'
import ApolloConfiguration from './ApolloConfiguration'
import CurrentUserConfiguration from './CurrentUserConfiguration'
import KpcAppTheme from './KpcAppTheme'
import { processEnv } from './environmentVariables'

const AppConfiguration: React.FC = ({ children }) => {
    return (
        <LoadingPageProvider>
            <LoadingPageContext.Consumer>
                {({ showLoadingScreenPage }: ILoadingPageContext) => (
                    <>
                        {showLoadingScreenPage && <LoadingScreenPage />}
                        <AppThemeConfiguration theme={KpcAppTheme}>
                            <BrowserRouter
                                getUserConfirmation={NavPromptDialogContainer}
                            >
                                <GlobalRouterConfiguration>
                                    <AuthProvider
                                        graphQlUri={
                                            processEnv.REACT_APP_GraphQLUri
                                        }
                                        kpCoreBaseDomainPath={
                                            processEnv.REACT_APP_KPCoreUri
                                        }
                                        allowedAccountTypeRoles={{
                                            System: ReviewerBaseRoles,
                                            AEFirm: ReviewerBaseRoles,
                                        }}
                                        b2cTenant={
                                            processEnv.REACT_APP_B2C_Tenant
                                        }
                                        b2cSignInPolicy={
                                            processEnv.REACT_APP_B2C_SignInPolicy
                                        }
                                        b2cApplicationId={
                                            processEnv.REACT_APP_B2C_ApplicationId
                                        }
                                    >
                                        <ApolloConfiguration>
                                            <CurrentUserConfiguration>
                                                <AppInsightContextProvider
                                                    instrumentationKey={
                                                        processEnv.REACT_APP_AppInsightInstrumentationKey
                                                    }
                                                >
                                                    <AppBarProvider appTitle="Specpoint">
                                                        {children}
                                                    </AppBarProvider>
                                                </AppInsightContextProvider>
                                            </CurrentUserConfiguration>
                                        </ApolloConfiguration>
                                    </AuthProvider>
                                </GlobalRouterConfiguration>
                            </BrowserRouter>
                        </AppThemeConfiguration>
                    </>
                )}
            </LoadingPageContext.Consumer>
        </LoadingPageProvider>
    )
}

export default AppConfiguration
